export default __webpack_public_path__ + "static/media/BannerRegistro_movil.6c561d55.jpg";